<template>
  <b-modal hide-footer :id="id" size="xl" button-size="sm" ref="modal" :title="prefix + title"
    v-model="showTarefaAprovacaoAlmoxarifadoModal" @hidden="cancelar" @close="cancelar">
    <ModalHistoricoPedido v-if="showModalHistoricoPedido" :title="' > Histórico de Pedido'"
      :prefix="'Pedido > Cadastro'" :almoxarifadoProdutoId="almoxarifadoProdutoId" @close="closeModalHistoricoPedido"
      @hidden="closeModalHistoricoPedido">
    </ModalHistoricoPedido>
    <ModalConsultaProduto v-if="showModalProduto" @onselect="addProduto" :prefix="prefix + title + ' > '"
      :departamento="this.departamento" @close="closeModalProduto" @hidden="closeModalProduto" :tipoOperacao="'pedido'"
      :almoxarifado="almoxarifado">
    </ModalConsultaProduto><b-card bg-variant="light">
      <b-card>
        <div>
          <span style="font-size: 16px">
            <strong>Pedido:</strong> {{ pedido.id }}<br />
            <strong>Solicitante:</strong>
            {{ pedido.departamentoSolicitante.descricao }} <br />
            <strong>Data:</strong> {{ formatarData(tarefa.dataCriacao) }}
            <br />
            <strong>Justificativa:</strong> {{ pedido.justificativa }}
            <br />
          </span>
        </div>
      </b-card>

      <b-col cols="12" class="text-left">
        <span style="font-size: 16px">
          <strong>Tarefa:</strong> {{ tarefa.tipoTarefaPedido.descricao }}<br />
          <strong>Status:</strong> {{ tarefa.status.descricao }}<br />
        </span>
      </b-col>
      <b-form-row v-if="!isVisualizacao">
        <b-col cols="12" class="text-right mb-2">
          <b-button id="adicionar" size="md" variant="success" style="height: 40px" @click="addProdutoIntent"><b-tooltip
              target="adicionar" title="Adicionar item ..."></b-tooltip>
            <div>Adicionar Produto</div>
          </b-button>
        </b-col>
      </b-form-row>

      <b-table id="t-tarefa-item" responsive class="mt-2" small :items="itens" :fields="fieldsTabelaItens"
        :busy="this.busy">
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>


        <template #cell(quantidadeAprovada)="data">
          <lg-number @input="atualizarSit" :disabled="isVisualizacao" v-model="data.item.quantidadeAprovada" required
            :precision="{ min: 0, max: 0 }" />
        </template>


        <template #cell(sitAtual)="data">
          <lg-number :disabled="true" v-model="data.item.quantidadeAprovada" required :precision="{ min: 0, max: 0 }" />
        </template>


        <template #cell(qtdSolicitada)="data">
          <lg-number :disabled="isVisualizacao || !data.item.novo" v-model="data.item.qtdSolicitada" required
            :precision="{ min: 0, max: 0 }" />
        </template>

        <template v-slot:cell(historico)="row">
          <b-button :id="'historico' + row.index" size="sm" variant="primary" @click="historicoPedido(row.item)">
            <b-icon icon="clock" />
            <b-tooltip :target="'historico' + row.index" title="Histórico de pedidos..."></b-tooltip>
          </b-button>
        </template>
      </b-table>
      <b-col lg="12" sm="12" class="text-left">
        <b-form-group label-for="textarea-formatter" class="col-12">
          <label for="textarea-auto-height">Observação:</label>
          <b-form-textarea :disabled="isVisualizacao" id="textarea-formatter" v-model="obs" :required="false">
          </b-form-textarea>
        </b-form-group>
      </b-col>

      <b-row class="text-center">
        <b-col cols="3"></b-col>
        <b-col cols="6">
          <b-button v-if="!isVisualizacao" id="salvarAprAlmoxarif" type="submit" variant="success" size="sm"
            :title="'Salvar'" @click="salvar(false)">
            Salvar
            <b-tooltip target="salvarAprAlmoxarif" title="Salvar"></b-tooltip>

          </b-button>
          <b-button v-if="!isVisualizacao" id="ConcluirAprAlmoxarif" variant="primary" size="sm" class="ml-2"
            @click="concluir">
            Concluir
            <b-tooltip target="ConcluirAprAlmoxarif" title="Prosseguir para a próxima tarefa"></b-tooltip>

          </b-button>
          <b-button id="cancelarAprAlmoxarif" variant="danger" size="sm" class="ml-2" @click="cancelar">
            Cancelar
            <b-tooltip target="cancelarAprAlmoxarif" title="Cancelar"></b-tooltip>
          </b-button>
        </b-col>

      </b-row>

    </b-card>
  </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgNumber from "@/core/components/Inputs/LgNumber.vue"
import ModalConsultaProduto from "@/core/components/Modals/ModalConsultaProduto.vue"
import ModalHistoricoPedido from "@/core/components/Modals/ModalHistoricoPedido.vue"

export default {
  components: { LgNumber, ModalConsultaProduto, ModalHistoricoPedido },

  data() {
    return {
      almoxarifado: null,
      showTarefaAprovacaoAlmoxarifadoModal: true,
      showModalProduto: false,
      showModalHistoricoPedido: false,
      almoxarifadoProdutoId: null,
      itens: [],
      departamento: null,
      obs: "",
    }
  },

  props: {
    id: String,
    pedido: Object,
    tarefa: Object,
    uri: String,
    isVisualizacao: {
      type: Boolean,
      value: false,
    },

    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Tarefa",
    },
  },

  async beforeMount() {
    this.$pedidoTarefa = new ResourceService(
      `/api/pedidos/${this.pedido.id}/tarefas`
    )

    this.$tarefaService = new ResourceService("/api/tarefaspedido")
    const brand = JSON.parse(localStorage.getItem("context"))
    this.departamentoSolicitante = brand.departamento
    this.tarefaItens()
  },

  computed: {
    fieldsTabelaItens() {
      return [
        {
          key: "itemPedido.almoxarifadoProduto.numero",
          label: "Número",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
          tdClass: "py-0",
        },
        {
          key: "itemPedido.almoxarifadoProduto.produto.descricaoResumida",
          label: "Produto",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
          tdClass: "py-0 ",
        },
        {
          key: "estoque",
          label: "Estoque",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
          tdClass: "text-center",
          formatter: value =>
            value !== null && value !== undefined ? value.toFixed(2) : "-",
        },
        {
          key: "duracaoEstoqueAtual",
          label: "Duração Estoque",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
          tdClass: "text-center",
          formatter: value =>
            value !== null && value !== undefined ? value.toFixed(2) : "-",
        },
        {
          key: "quantidadeUtilizada",
          label: "Utilizado",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
          tdClass: "text-center",
          formatter: value =>
            value !== null && value !== undefined ? value : "-",
        },
        {
          key: "qtdSolicitada",
          label: "Solicitado",
          tdClass: "text-center",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
          formatter: value =>
            value !== null && value !== undefined ? value.toFixed(2) : "-",
        },
        {
          key: "quantidadeAprovada",
          label: "Aprovado",
          tdClass: "py-0",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
          formatter: value => value || "-",
        },
        {
          key: "sitAtual",
          label: "Sit. Atual",
          tdClass: "text-center",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "historico",
          label: "",
          tdClass: "py-0",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
      ]
    },
  },

  methods: {
    atualizarSit(item) {
      item
    },
    validar(itens) {

      if (itens.some(item => !item.quantidadeAprovada || item.quantidadeAprovada <= 0)) {
        this.$notify({
          type: "danger",
          message:
            "Quantidade aprovada não pode ser menor ou igual a 0",
        });

        return false;
      }

      if (itens.some(item => !item.qtdSolicitada || item.qtdSolicitada <= 0)) {
        this.$notify({
          type: "danger",
          message:
            "Quantidade solicitada não pode ser menor ou igual a 0",
        });

        return false;
      }

      if (itens.some(item => item.quantidadeAprovada > item.qtdSolicitada)) {
        this.$notify({
          type: "danger",
          message:
            "Quantidade aprovada não pode ser maior do que a quantidade solicitada",
        });

        return false;
      }

      return true;

    },
    async salvar(concluir) {
      this.$pedidoTarefa = new ResourceService(
        `/api/pedidos/${this.pedido.id}/tarefas`
      );


      try {
        if (!this.validar(this.itens))
          return;

        const itens = this.itens.map(({ itemPedido, quantidadeAprovada, qtdSolicitada }) => ({
          produtoId: itemPedido.almoxarifadoProduto.produto.id,
          itemPedidoId: itemPedido.id,
          quantidadeAprovada: quantidadeAprovada,
          almoxarifadoProduto: itemPedido.almoxarifadoProduto.id,
          qtdSolicitada: qtdSolicitada
        }));

        this.busy = true;
        await this.$pedidoTarefa.put(`${this.tarefa.id}${this.uri}`, {
          pedido: this.tarefa.pedido,
          itens,
          observacao: this.obs,
        });

        this.busy = true;

        if (!concluir) {
          this.$notify({
            type: "success",
            message: "Registro salvo com sucesso",
          });
          this.cancelar()

        }
        else {
          this.concluirTarefa();
        }

      } catch ({ response }) {
          this.$notify({ type: 'danger', message: response.data });
          return;
        }
    },

    async concluir() {
      this.salvar(true);
    },

    async concluirTarefa() {

      try {
        if (!this.validar(this.itens))
          return;

        const itens = this.itens.map(({ itemPedido, quantidadeAprovada, qtdSolicitada }) => ({
          produtoId: itemPedido.almoxarifadoProduto.produto.id,
          itemPedidoId: itemPedido.id,
          quantidadeAprovada: quantidadeAprovada,
          almoxarifadoProduto: itemPedido.almoxarifadoProduto.id,
          qtdSolicitada: qtdSolicitada
        }));



        this.busy = true;

        await this.$tarefaService
          .put(`executaProximaTarefa`, {
            id: this.tarefa.id,
            pedido: this.pedido,
            itens,
            observacao: this.obs,
          })
          .then(response => {
            if (response.status === 204 || response.status === 200) {
              this.$emit("tarefaAprovacaoAlmoxarifadoFinalizado", {})
              this.showTarefaAprovacaoAlmoxarifadoModal = false;
              this.busy = false;

              this.$notify({
                type: "success",
                message: "Tarefa finalizada com sucesso",
              })

            }
          })
        } catch ({ response }) {
          this.$notify({ type: 'danger', message: response.data });
          return;
        }
    },

    async tarefaItens() {
      this.busy = true
      await this.$tarefaService
        .findById(`${this.tarefa.id}${this.uri}`)
        .then(response => {
          this.busy = false
          this.almoxarifado = response.data.almoxarifado.id;
          this.itens = response.data.itens;
          this.obs = response.data.observacao;

        });
    },

    async cancelar() {
      this.showTarefaAprovacaoAlmoxarifadoModal = false
      this.$emit("close")
    },

    async addProdutoIntent() {
      this.showModalProduto = true
    },
    async addProduto(produto) {
      const produtoExistente = this.itens.find(
        item => item.itemPedido.almoxarifadoProduto.id === produto.produto.id
      )
      if (produtoExistente) {
        this.$notify({
          type: "danger",
          message: "Esse Item já se encontra na lista",
        });
        return;
      }
      this.itens.push({
        novo: true,
        itemPedido: {
          qtdSolicitada: 0,
          almoxarifadoProduto: {
            id: produto.id,
            numero: produto.numero,
            produto: {
              id: produto.produto.id,
              numero: produto.produto.numero,
              descricaoResumida: produto.produto.descricaoResumida,
            },
            quantidadeAprovada: 0,
          },
        },
      })
    },

    historicoPedido(item) {
      this.almoxarifadoProdutoId = item.itemPedido.almoxarifadoProduto.id
      this.showModalHistoricoPedido = true
    },

    closeModalHistoricoPedido() {
      this.showModalHistoricoPedido = false
    },
    closeModalProduto() {
      this.showModalProduto = false
    },

    formatarData: function (valor) {
      if (!valor) return ""

      const data = new Date(valor)
      const dia = data.getDate().toString().padStart(2, "0")
      const mes = (data.getMonth() + 1).toString().padStart(2, "0")
      const ano = data.getFullYear()
      const hora = data.getHours().toString().padStart(2, "0")
      const minutos = data.getMinutes().toString().padStart(2, "0")
      const segundos = data.getSeconds().toString().padStart(2, "0")

      return `${dia}/${mes}/${ano} ${hora}:${minutos}:${segundos}`
    },
  },
}
</script>
<style lang="scss">
.modal-footer,
.modal-body {
  padding: 0.25rem !important;
}

table {
  .form-control {
    padding: 3px 9px;
    height: 30px;
    text-align: right;
  }
}
</style>
